import Resource from "./resource.js";
export class OpenIdFederations extends Resource {
    /**
     * Identity Federation
     * https://www.keycloak.org/docs-api/11.0/rest-api/#_identity_providers_resource
     */
    find = this.makeRequest({
        method: "GET",
    });
    findOne = this.makeRequest({
        method: "GET",
        path: "/{internalId}",
        urlParamKeys: ["internalId"],
        catchNotFound: true,
    });
    update = this.makeUpdateRequest({
        method: "PUT",
        path: "/{internalId}",
        urlParamKeys: ["internalId"],
    });
    create = this.makeRequest({
        method: "POST",
        returnResourceIdInLocationHeader: { field: "id" },
    });
    del = this.makeRequest({
        method: "DELETE",
        path: "/{internalId}",
        urlParamKeys: ["internalId"],
    });
    constructor(client) {
        super(client, {
            path: "/admin/realms/{realm}/openid-federations",
            getUrlParams: () => ({
                realm: client.realmName,
            }),
            getBaseUrl: () => client.baseUrl,
        });
    }
}
//# sourceMappingURL=openIdFederations.js.map